import type { SVGProps } from "react";

export const Walmart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    viewBox="0 0 122.88 122.88"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Walmart</title>{" "}
    <path
      d="M38.24,0h46.4a38.36,38.36,0,0,1,38.24,38.24v46.4a38.36,38.36,0,0,1-38.24,38.24H38.24A38.36,38.36,0,0,1,0,84.64V38.24A38.36,38.36,0,0,1,38.24,0Z"
      fill="#1d7ad9"
      fillRule="evenodd"
    />{" "}
    <path
      d="M61.43,20.82c-3.09,0-5.54,1.73-5.54,3.83L57.77,45.9c.2,1.28,1.77,2.27,3.67,2.27s3.46-1,3.67-2.27L67,24.65c0-2.1-2.47-3.82-5.56-3.82Zm-30.58,17a6,6,0,0,0-4.58,3.26c-1.55,2.68-1.28,5.67.53,6.72l19.34,9c1.21.45,2.85-.41,3.8-2h0c1-1.65.88-3.5-.12-4.32L32.35,38.24a2.86,2.86,0,0,0-1.5-.37Zm61.17,0a2.86,2.86,0,0,0-1.5.37L73.05,50.49c-1,.82-1.07,2.67-.12,4.32h0c.95,1.64,2.59,2.5,3.8,2l19.34-9c1.83-1.05,2.09-4,.55-6.72A6,6,0,0,0,92,37.87Zm-45.15,28a1.73,1.73,0,0,0-.72.12L26.81,75c-1.82,1.06-2.09,4-.54,6.73s4.27,3.94,6.08,2.89L49.82,72.4c1-.83,1.08-2.68.13-4.32h0a3.94,3.94,0,0,0-3.08-2.17Zm29.14,0a3.94,3.94,0,0,0-3.08,2.17h0c-1,1.64-.87,3.49.13,4.32L90.53,84.64c1.81,1,4.53-.22,6.09-2.89s1.28-5.67-.55-6.73L76.73,66a1.76,1.76,0,0,0-.72-.12ZM61.43,74.72c-1.89,0-3.46,1-3.66,2.26L55.89,98.23c0,2.1,2.46,3.83,5.55,3.83S67,100.33,67,98.23L65.11,77c-.21-1.28-1.77-2.26-3.67-2.26Z"
      fill="#ffc220"
    />
  </svg>
);

export default Walmart;
